import { render, staticRenderFns } from "./transferStation.vue?vue&type=template&id=194080f5&scoped=true&"
import script from "./transferStation.vue?vue&type=script&lang=js&"
export * from "./transferStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194080f5",
  null
  
)

export default component.exports